import { http } from '@/lib/http'
import { wsPath } from '@/lib/api/workspace-context'

export interface PredicateDefinition {
  id: string
  name: string
  namespace: string
  entityType: string
  valueType: string
  cardinalityMode: string
  canonicalizationRule: string | null
  description: string | null
}

export interface EntityFact {
  id: string
  workspaceId: string
  entityId: string
  predicateId: string
  value: string
  normalizedValue: string
  valueType: string
  sourceType: string
  sourceRef: string | null
  corroborationCount: number
  confidence: number
  recordedAt: string
  observedAt: string
  effectiveFrom: string | null
  effectiveTo: string | null
  supersededBy: string | null
  updatedAt: string
}

export async function getPredicateManifest(
  authToken: string | null,
  entityType: string,
): Promise<PredicateDefinition[]> {
  const response = await http.get<{ items: PredicateDefinition[] }>(
    wsPath(`/predicates?entityType=${encodeURIComponent(entityType)}`),
    { authToken },
  )
  return response.data.items
}

export async function getEntityFacts(
  authToken: string | null,
  entityId: string,
): Promise<EntityFact[]> {
  const response = await http.get<{ items: EntityFact[] }>(
    wsPath(`/entities/${entityId}/facts`),
    { authToken },
  )
  return response.data.items
}

export async function updateEntityFact(
  authToken: string | null,
  factId: string,
  value: string,
): Promise<EntityFact> {
  const response = await http.patch<EntityFact>(
    wsPath(`/facts/${factId}`),
    { value },
    { authToken },
  )
  return response.data
}

export async function deleteEntityFact(
  authToken: string | null,
  factId: string,
): Promise<void> {
  await http.delete(wsPath(`/facts/${factId}`), { authToken })
}
